import axios from "../../../axios";
import React, { useEffect, useState } from "react";
import { BiSlideshow } from "react-icons/bi";
import { GiNotebook } from "react-icons/gi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

/**
 * Displayes all events (Assesment, Slide show etc. ) in the event
 * @param {*} param0
 * @returns
 */
const TimeTableEvents = ({ event }) => {
  const navigate = useNavigate();

  const [activity, setActivity] = useState([]);
  const [homework, setHomework] = useState([]);
  const [preRead, setPreRead] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [assClick, setAssClick] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  const [status, setStatus] = useState({
    assessment: "",
    preRead: "",
    activity: "",
    homework: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      try {

        const resources = [
          {
            type: "assessment",
            id: assessment?.id,
            setStatusKey: "assessment",
          },
          {
            type: "preRead",
            id: preRead?.id,
            setStatusKey: "preRead",
          },
          {
            type: "activity",
            id: activity?.id,
            setStatusKey: "activity",
          },
          {
            type: "homework",
            id: homework?.id,
            setStatusKey: "homework",
          },
        ];

        for (const resource of resources) {
          if (resource.id) {
            const response = await axios.get(
              `/${resource.type}/studentStatus/${resource.type}Id/${resource.id}/studentId/${currentUser?.id}`
            );
            setStatus((prevStatuses) => ({
              ...prevStatuses,
              [resource.setStatusKey]: response.data.data.status,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      console.log(status);
    };

    fetchData();
  }, [assessment, homework, activity, preRead, currentUser]);
  function getRRoutefromStatus(status, assessmentId) {
    let url;
    switch (status) {
      case "completed":
        url = `/Assessment/completed`;
        break;
      case "pending":
        // url = `/Assessment/pending/questions/${assessmentId}`;
        setAssClick(true);
        return;
      case "review":
        url = `/Assessment/review/questions`;
        break;
      default:
        url = "/Calender";
    }
    navigate(url, { state: { assessmentId: assessmentId } });
    return;
  }

  function getRRoutefromStatusPreRead(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/presRead/completed`;
        break;
      case "pending":
        url = `/preReads/published`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { preReadId: id } });
    return;
  }

  function getRRoutefromStatusActivity(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/completedActivity`;
        break;
      case "pending":
        url = `/publishedActivity`;
        break;
      case "review":
        url = `/reviewActivity`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { activityId: id } });
    return;
  }

  function getRRoutefromStatusHomework(status, id) {
    let url;
    switch (status) {
      case "completed":
        url = `/completedHomework`;
        break;
      case "pending":
        url = `/publishedhomework`;
        break;
      case "review":
        url = `/reviewHomework`;
        break;
      default:
        url = "/Calender";
        break;
    }
    navigate(url, { state: { homeworkId: id } });
    return;
  }
  useEffect(() => {
    const handleSupplementDetails = async () => {
      event?.Events?.forEach((obj) => {
        if (obj.name === "activity") {
          axios.get(`/homework/activity/getById/${obj.value}`).then((res) => {
            res && setActivity(res.data.data);
          });
        }
        if (obj.name === "pre_read") {
          axios.get(`/homework/preRead/getById/${obj.value}`).then((res) => {
            res && setPreRead(res.data.data);
          });
        }
        if (obj.name === "assessment") {
          axios.get(`/assessment/getForStudent/${obj.value}`).then((res) => {
            res && setAssessment(res.data.data);
          });
        }
        if (obj.name === "homework") {
          axios.get(`/homework/get/${obj.value}`).then((res) => {
            res && setHomework(res.data.data);
          });
        }
      });
    };
    handleSupplementDetails();
  }, [event]);
  
  return event.Events !== 'Planner' ? (
    <>
      <div className="event-icons-container col">
        <div className="container">
          <div className="gap-2 d-flex gap-4">
            {event?.Events?.map((item, index) => {
              switch (item.name) {
                case "assessment":
                  return (
                    <div key={index} onClick={() => { localStorage?.setItem("From", "DCM") }}>
                      {/* <Link className='link_dcm_summary' to={`/Assessment/pending/questions/${assessment?.id}`}> */}
                      <img src="/DCM-img/assessment.svg" alt="" onClick={() => {
                        localStorage.setItem("from", 'DCM');
                        getRRoutefromStatus(
                          status.assessment,
                          assessment?.id
                        )
                      }
                      }></img>
                      {/* </Link> */}
                    </div>
                  );
                case "homework":
                  return (
                    <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                      {/* <Link className='link_dcm_summary' to={`/publishedHomework/${homework?.id}`}>  */}
                      <img src="/DCM-img/homework.svg" alt="" onClick={() =>
                        getRRoutefromStatusHomework(
                          status.homework,
                          homework?.id
                        )
                      }></img>
                      {/* </Link> */}
                    </div>
                  );
                case "activity":
                  return (
                    <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                      {/* <Link className='link_dcm_summary' to={`/publishedActivity/${activity?.id}`}>  */}
                      <img src="/DCM-img/activity.svg" alt="" onClick={() => {
                        getRRoutefromStatusActivity(
                          status.activity,
                          activity?.id
                        );
                      }}></img>
                      {/* </Link> */}
                    </div>
                  );
                case "pre_read":
                  return (
                    <div key={index} onClick={() => { localStorage.setItem("From", "DCM") }}>
                      {/* <Link className='link_dcm_summary' to={`/preReads/published/${preRead?.id}`}>  */}
                      <img src="/DCM-img/preread.svg" alt="" onClick={() => {
                        getRRoutefromStatusPreRead(
                          status.preRead,
                          preRead?.id
                        );
                      }}></img>
                      {/* </Link> */}
                    </div>
                  );
                default:
                  return <></>;
              }
            })}
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <p>{event?.description}</p>
    </>
  );
};

export default TimeTableEvents;
